module.exports = __webpack_public_path__ + "img/volkswagen-logo.3fb66c6f.webp";